import React from "react";

interface IconProps {
  scale?: number;
}

export const RulerIcon: React.FC<IconProps> = ({ scale = 1 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19 * scale}
    height={19 * scale}
    viewBox="0 0 19 19"
  >
    <g id="interface-edit-ruler" transform="translate(0.707 0.707)">
      <rect
        id="Rectangle_88"
        data-name="Rectangle 88"
        width="17.621"
        height="7.835"
        transform="translate(0 12.46) rotate(-45)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <line
        id="Ligne_14"
        data-name="Ligne 14"
        x2="2.076"
        y2="2.076"
        transform="translate(9.688 2.776)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <line
        id="Ligne_15"
        data-name="Ligne 15"
        x2="2.076"
        y2="2.076"
        transform="translate(6.227 6.236)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <line
        id="Ligne_16"
        data-name="Ligne 16"
        x2="2.076"
        y2="2.076"
        transform="translate(2.767 9.697)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
    </g>
  </svg>
);

export const StarIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={18*scale}
      viewBox="0 0 19 18"
    >
      <g id="star_icon" data-name="star icon" transform="translate(0.03 0.02)">
        <path
          id="Tracé_226"
          data-name="Tracé 226"
          d="M12.173,2.918l2.2,4.458a.749.749,0,0,0,.565.41l4.92.715a.75.75,0,0,1,.416,1.279l-3.56,3.47a.75.75,0,0,0-.216.664l.84,4.9a.75.75,0,0,1-1.088.791l-4.4-2.313a.75.75,0,0,0-.7,0L6.751,19.6a.75.75,0,0,1-1.088-.791l.84-4.9a.75.75,0,0,0-.216-.664L2.728,9.78A.75.75,0,0,1,3.143,8.5l4.92-.715a.749.749,0,0,0,.565-.41l2.2-4.458A.75.75,0,0,1,12.173,2.918Z"
          transform="translate(-2.021 -2.02)"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const ArrowIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={18*scale}
      viewBox="0 0 19 18"
    >
      <g
        id="upload-circle--arrow-circle-download-internet-network-server-up-upload"
        transform="translate(26.224 -7.975) rotate(90)"
      >
        <path
          id="Vector"
          d="M4,13.185,12.3,3.5l8.3,9.685"
          transform="translate(4.68 4.224)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Vector_2"
          d="M7,3.5V20.868"
          transform="translate(9.982 4.857)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const BrightnessIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={19*scale}
      viewBox="0 0 19 19"
    >
      <g id="brightness-1" transform="translate(-5 -5.001)">
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="2.769"
          cy="2.769"
          r="2.769"
          transform="translate(11.731 11.732)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_25"
          data-name="Ligne 25"
          x2="2.769"
          transform="translate(5.5 14.501)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_26"
          data-name="Ligne 26"
          y1="1.956"
          x2="1.958"
          transform="translate(8.135 18.908)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_27"
          data-name="Ligne 27"
          y1="2.769"
          transform="translate(14.5 20.732)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_28"
          data-name="Ligne 28"
          x1="1.958"
          y1="1.958"
          transform="translate(18.906 18.907)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_29"
          data-name="Ligne 29"
          x1="2.769"
          transform="translate(20.731 14.501)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_30"
          data-name="Ligne 30"
          x1="1.958"
          y2="1.958"
          transform="translate(18.906 8.139)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_31"
          data-name="Ligne 31"
          y2="2.769"
          transform="translate(14.5 5.501)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_32"
          data-name="Ligne 32"
          x2="1.958"
          y2="1.958"
          transform="translate(8.135 8.139)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const ArrowRightIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      id="arrow-right-1"
      xmlns="http://www.w3.org/2000/svg"
      width={9.329*scale}
      height={18*scale}
      viewBox="0 0 9.329 18"
    >
      <path
        id="Tracé_224"
        data-name="Tracé 224"
        d="M5.312,18a.557.557,0,0,1-.4-.165.564.564,0,0,1,0-.8L12.954,9,4.914.96a.561.561,0,0,1,0-.8.561.561,0,0,1,.8,0l8.04,8.04a1.125,1.125,0,0,1,0,1.589L5.709,17.835A.557.557,0,0,1,5.312,18Z"
        transform="translate(-4.749 0)"
        fill="currentColor"
      />
    </svg>
  );
};

export const ColorPaletteIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={17.615*scale}
      viewBox="0 0 19 17.615"
    >
      <g id="interface-edit-color-palette" transform="translate(0.5 0.5)">
        <circle
          id="Ellipse_3"
          data-name="Ellipse 3"
          cx="5.538"
          cy="5.538"
          r="5.538"
          transform="translate(0 5.538)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <circle
          id="Ellipse_4"
          data-name="Ellipse 4"
          cx="5.538"
          cy="5.538"
          r="5.538"
          transform="translate(6.923 5.538)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <circle
          id="Ellipse_5"
          data-name="Ellipse 5"
          cx="5.538"
          cy="5.538"
          r="5.538"
          transform="translate(3.462)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const InformationCircleIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      id="information-circle--information-frame-info-more-help-point-circle"
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={19*scale}
      viewBox="0 0 19 19"
    >
      <path
        id="Vector"
        d="M9.5,18.5a9,9,0,1,0-9-9,9,9,0,0,0,9,9Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Vector_2"
        d="M5.5,10H9.654"
        transform="translate(1.923 3.654)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Vector_3"
        d="M7.385,11.346V6.5H6"
        transform="translate(2.115 2.308)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <g id="Group_2605" data-name="Group 2605" transform="translate(9.154 5)">
        <path
          id="Ellipse_1111"
          data-name="Ellipse 1111"
          d="M7.1,4.442a.346.346,0,1,1,0-.692"
          transform="translate(-6.75 -3.75)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Ellipse_1112"
          data-name="Ellipse 1112"
          d="M7,4.442A.346.346,0,0,0,7,3.75"
          transform="translate(-6.654 -3.75)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const WeatherNightClearIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={18.32*scale}
      viewBox="0 0 19 18.32"
    >
      <g id="weather-night-clear" transform="translate(-0.745 -1.106)">
        <path
          id="Tracé_227"
          data-name="Tracé 227"
          d="M15.1,1.75l-.913,2.434L11.75,5.1l2.435.912L15.1,8.447l.913-2.436L18.447,5.1l-2.435-.914L15.1,1.75"
          transform="translate(-1.711)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Tracé_228"
          data-name="Tracé 228"
          d="M20.424,9.75l-.456,1.217-1.218.457,1.218.456.456,1.218.456-1.218,1.218-.456-1.218-.457L20.424,9.75"
          transform="translate(-2.851 -1.303)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Tracé_229"
          data-name="Tracé 229"
          d="M15.062,14.459a7.116,7.116,0,0,1-6.8-9.2,7.116,7.116,0,1,0,6.909,9.2C15.133,14.454,15.1,14.459,15.062,14.459Z"
          transform="translate(0 -0.571)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const SettingSliderHorizontalIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={19*scale}
      viewBox="0 0 19 19"
    >
      <g
        id="interface-setting-slider-horizontal"
        transform="translate(0.5 0.5)"
      >
        <circle
          id="Ellipse_8"
          data-name="Ellipse 8"
          cx="2.077"
          cy="2.077"
          r="2.077"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_17"
          data-name="Ligne 17"
          x2="13.846"
          transform="translate(4.154 2.077)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <circle
          id="Ellipse_9"
          data-name="Ellipse 9"
          cx="2.077"
          cy="2.077"
          r="2.077"
          transform="translate(6.923 6.923)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_18"
          data-name="Ligne 18"
          x2="6.923"
          transform="translate(0 9)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_19"
          data-name="Ligne 19"
          x2="6.923"
          transform="translate(11.077 9)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <circle
          id="Ellipse_10"
          data-name="Ellipse 10"
          cx="2.077"
          cy="2.077"
          r="2.077"
          transform="translate(13.846 13.846)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Ligne_20"
          data-name="Ligne 20"
          x1="13.846"
          transform="translate(0 15.923)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const StairsDescendIcon: React.FC<IconProps> = ({ scale = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19*scale}
      height={16.158*scale}
      viewBox="0 0 19 16.158"
    >
      <g id="stairs-descend" transform="translate(0 -7)">
        <path
          id="Tracé_230"
          data-name="Tracé 230"
          d="M.5,7.5H6.658a.474.474,0,0,1,.474.474v3.316h3.316a.474.474,0,0,1,.474.474v3.316h3.316a.474.474,0,0,1,.474.474v3.316h3.316a.474.474,0,0,1,.474.474v3.316"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};
